import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { RegisterMachine } from '../../components/machine/registration/register-machine';
import { useBeaconRouter } from '../../route/route.hooks';

interface RegisterMachinePage {
  teamId: string;
}

const RegisterMachinePage = (props: RegisterMachinePage): ReactElement => {
  const { teamId } = props;
  const { i18n } = useTranslation();

  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <NestedPageHeader
        title={i18n.t('common:machine_new')}
        defaultBackRoute={builder.getMachinesRoute(teamId)}
      />
      <IonContent>
        <RegisterMachine teamId={teamId} />
      </IonContent>
    </IonPage>
  );
};

export { RegisterMachinePage };
